import { Action, createReducer, on } from '@ngrx/store';
import { GenesysCloudIntegrationState as State, initialState } from '../genesys-cloud-integrations.state';
import * as IntegrationActions from '../actions/integrations.actions';
import { IntendedState } from 'common/auth/models/intended-state';

export const reducer = createReducer(
  initialState(),
  on(
    IntegrationActions.organizationPairingIntegrationLoaded,
    (state, { orgPairingIntegration }): State => ({
      ...state,
      orgPairingLoaded: true,
      hasOrgPairingIntegration: !!orgPairingIntegration && orgPairingIntegration.intendedState === IntendedState.ENABLED
    })
  )
);

export function genesysCloudIntegrationsReducer(state: State, action: Action): State {
  return reducer(state, action);
}
